import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { PersonalCoachingWidgetComponent } from './personal-coaching.widget.component';
import { TeamCoachingDetailsWidgetComponent } from './team-coaching-details.widget.component';
import {
    TeamCoaching,
    TeamCoachingItem,
    TeamCoachingPerformerType,
} from './team-coaching.widget.model';

@Component({
    selector: 'cmps-widget-team-coaching',
    templateUrl: './team-coaching.widget.component.html',
})
export class TeamCoachingWidgetComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    TeamCoachingPerformerType = TeamCoachingPerformerType;
    hasPendingData: boolean;
    data: TeamCoaching;
    private _modal: NgbModalRef;

    constructor(
        private readonly _modalService: NgbModal,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _service: LegacyWidgetService,
    ) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .teamCoaching()
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    showDetails(item: TeamCoachingItem): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            size: 'lg',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component:
                item.performerType === TeamCoachingPerformerType.WITHOUT_GOALS
                    ? TeamCoachingDetailsWidgetComponent
                    : PersonalCoachingWidgetComponent,
            options: { performerType: item.performerType },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
